import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { FormattedDate } from "react-intl";
import { connect } from "alt-react";
import WalletActions from "actions/WalletActions";
import WalletManagerStore from "stores/WalletManagerStore";
import BackupStore from "stores/BackupStore";
import WalletDb from "stores/WalletDb";
import BackupActions, { backup, decryptWalletBackup } from "actions/BackupActions";
import { saveAs } from "file-saver";
import Translate from "react-translate-component";
import { PrivateKey } from "bitsharesjs";
import SettingsActions from "actions/SettingsActions";
import { backupName } from "common/backupUtils";
import { getWalletName } from "branding";
import { Button, Input, Notification } from "bitshares-ui-style-guide";
import counterpart from "counterpart";
const connectObject = {
  listenTo() {
    return [WalletManagerStore, BackupStore];
  },

  getProps() {
    let wallet = WalletManagerStore.getState();
    let backup = BackupStore.getState();
    return {
      wallet,
      backup
    };
  }

}; //The default component is WalletManager.jsx

class BackupCreate extends Component {
  render() {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        maxWidth: "40rem"
      }
    }, /*#__PURE__*/React.createElement(Create, {
      noText: this.props.noText,
      newAccount: this.props.location && this.props.location.query ? this.props.location.query.newAccount : null
    }, /*#__PURE__*/React.createElement(NameSizeModified, null), this.props.noText ? null : /*#__PURE__*/React.createElement(Sha1, null), /*#__PURE__*/React.createElement(Download, {
      downloadCb: this.props.downloadCb
    })));
  }

}

BackupCreate = connect(BackupCreate, connectObject); // layout is a small project
// class WalletObjectInspector extends Component {
//     static propTypes={ walletObject: PropTypes.object }
//     render() {
//         return <div style={{overflowY:'auto'}}>
//             <Inspector
//                 data={ this.props.walletObject || {} }
//                 search={false}/>
//         </div>
//     }
// }

class BackupRestore extends Component {
  constructor() {
    super();
    this.state = {
      newWalletName: null
    };
  }

  UNSAFE_componentWillMount() {
    BackupActions.reset();
  }

  render() {
    let new_wallet = this.props.wallet.new_wallet;
    let has_new_wallet = this.props.wallet.wallet_names.has(new_wallet);
    let restored = has_new_wallet;
    const wallet_types = /*#__PURE__*/React.createElement(Link, {
      to: "/help/introduction/wallets"
    }, counterpart.translate("wallet.wallet_types"));
    const backup_types = /*#__PURE__*/React.createElement(Link, {
      to: "/help/introduction/backups"
    }, counterpart.translate("wallet.backup_types"));
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Translate, {
      style: {
        textAlign: "left",
        maxWidth: "30rem"
      },
      component: "p",
      content: "wallet.import_backup_choose"
    }), /*#__PURE__*/React.createElement(Translate, {
      className: "text-left",
      component: "p",
      wallet: wallet_types,
      backup: backup_types,
      content: "wallet.read_more"
    }), new FileReader().readAsBinaryString ? null : /*#__PURE__*/React.createElement("p", {
      className: "error"
    }, "Warning! You browser doesn't support some some file operations required to restore backup, we recommend you to use Chrome or Firefox browsers to restore your backup."), /*#__PURE__*/React.createElement(Upload, null, /*#__PURE__*/React.createElement(NameSizeModified, null), /*#__PURE__*/React.createElement(DecryptBackup, {
      saveWalletObject: true
    }, /*#__PURE__*/React.createElement(NewWalletName, null, /*#__PURE__*/React.createElement(Restore, null)))), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Link, {
      to: "/"
    }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.back"
    }))));
  }

}

BackupRestore = connect(BackupRestore, connectObject);

class Restore extends Component {
  constructor() {
    super();
    this.state = {};
  }

  isRestored() {
    let new_wallet = this.props.wallet.new_wallet;
    let has_new_wallet = this.props.wallet.wallet_names.has(new_wallet);
    return has_new_wallet;
  }

  render() {
    let new_wallet = this.props.wallet.new_wallet;
    let has_new_wallet = this.isRestored();
    if (has_new_wallet) return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("h5", null, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.restore_success",
      name: new_wallet.toUpperCase()
    })), /*#__PURE__*/React.createElement(Link, {
      to: "/"
    }, /*#__PURE__*/React.createElement(Button, {
      type: "primary"
    }, /*#__PURE__*/React.createElement(Translate, {
      component: "span",
      content: "header.dashboard"
    }))), /*#__PURE__*/React.createElement("div", null, this.props.children));
    return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.ready_to_restore"
    })), /*#__PURE__*/React.createElement(Button, {
      type: "primary",
      onClick: this.onRestore.bind(this)
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.restore_wallet_of",
      name: new_wallet
    })));
  }

  onRestore() {
    WalletActions.restore(this.props.wallet.new_wallet, this.props.backup.wallet_object);
    SettingsActions.changeSetting({
      setting: "passwordLogin",
      value: false
    });
  }

}

Restore = connect(Restore, connectObject);

class NewWalletName extends Component {
  constructor() {
    super();
    this.state = {
      new_wallet: null,
      accept: false
    };
  }

  UNSAFE_componentWillMount() {
    let has_current_wallet = !!this.props.wallet.current_wallet;

    if (!has_current_wallet) {
      let walletName = "default";

      if (this.props.backup.name) {
        walletName = this.props.backup.name.match(/[a-z0-9_-]*/)[0];
      }

      WalletManagerStore.setNewWallet(walletName);
      this.setState({
        accept: true
      });
    }

    if (has_current_wallet && this.props.backup.name && !this.state.new_wallet) {
      // begning of the file name might make a good wallet name
      let new_wallet = this.props.backup.name.toLowerCase().match(/[a-z0-9_-]*/)[0];
      if (new_wallet) this.setState({
        new_wallet
      });
    }
  }

  render() {
    if (this.state.accept) return /*#__PURE__*/React.createElement("span", null, this.props.children);
    let has_wallet_name = !!this.state.new_wallet;
    let has_wallet_name_conflict = has_wallet_name ? this.props.wallet.wallet_names.has(this.state.new_wallet) : false;
    let name_ready = !has_wallet_name_conflict && has_wallet_name;
    return /*#__PURE__*/React.createElement("form", {
      onSubmit: this.onAccept.bind(this)
    }, /*#__PURE__*/React.createElement("h5", null, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.new_wallet_name"
    })), /*#__PURE__*/React.createElement(Input, {
      type: "text",
      id: "new_wallet",
      onChange: this.formChange.bind(this),
      value: this.state.new_wallet
    }), /*#__PURE__*/React.createElement("p", null, has_wallet_name_conflict ? /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.wallet_exist"
    }) : null), /*#__PURE__*/React.createElement(Button, {
      onClick: this.onAccept.bind(this),
      type: "primary",
      disabled: !name_ready
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.accept"
    })));
  }

  onAccept(e) {
    if (e) e.preventDefault();
    this.setState({
      accept: true
    });
    WalletManagerStore.setNewWallet(this.state.new_wallet);
  }

  formChange(event) {
    let key_id = event.target.id;
    let value = event.target.value;

    if (key_id === "new_wallet") {
      //case in-sensitive
      value = value.toLowerCase(); // Allow only valid file name characters

      if (/[^a-z0-9_-]/.test(value)) return;
    }

    let state = {};
    state[key_id] = value;
    this.setState(state);
  }

}

NewWalletName = connect(NewWalletName, connectObject);

class Download extends Component {
  UNSAFE_componentWillMount() {
    try {
      this.isFileSaverSupported = !!new Blob();
    } catch (e) {}
  }

  componentDidMount() {
    if (!this.isFileSaverSupported) {
      Notification.error({
        message: counterpart.translate("notifications.backup_file_save_unsupported")
      });
    }

    if (this.props.confirmation) {
      this.createBackup();
    }
  }

  getBackupName() {
    return backupName(this.props.wallet.current_wallet);
  }

  createBackup() {
    const backupPubkey = WalletDb.getWallet().password_pubkey;
    backup(backupPubkey).then(contents => {
      const name = this.getBackupName();
      BackupActions.incommingBuffer({
        name,
        contents
      });
    });
  }

  render() {
    let isReady = true;

    if (this.props.confirmation) {
      isReady = this.props.checkboxActive;
    }

    return /*#__PURE__*/React.createElement(Button, {
      type: "primary",
      disabled: !isReady,
      onClick: () => {
        this.onDownload();
      },
      style: this.props.confirmation ? {
        height: "initial",
        padding: 0
      } : {}
    }, this.props.confirmation ? /*#__PURE__*/React.createElement("div", {
      className: "download-block",
      style: {
        padding: "1.25rem"
      }
    }, /*#__PURE__*/React.createElement("img", {
      className: "bin-img",
      src: "/bin-file/default.svg",
      alt: "bin"
    }), /*#__PURE__*/React.createElement("span", {
      className: "text-left"
    }, /*#__PURE__*/React.createElement(Translate, {
      className: "download-text",
      content: "registration.downloadFile"
    }), /*#__PURE__*/React.createElement("p", {
      className: "file-name",
      style: {
        marginBottom: 0
      }
    }, this.props.backup.name))) : /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.download"
    }));
  }

  onDownload() {
    const blob = new Blob([this.props.backup.contents], {
      type: "application/octet-stream; charset=us-ascii"
    });

    if (blob.size !== this.props.backup.size) {
      throw new Error("Invalid backup to download conversion");
    }

    saveAs(blob, this.props.backup.name);
    WalletActions.setBackupDate();

    if (this.props.downloadCb) {
      this.props.downloadCb();
    }
  }

}

Download = connect(Download, connectObject);

class Create extends Component {
  getBackupName() {
    return backupName(this.props.wallet.current_wallet);
  }

  render() {
    let has_backup = !!this.props.backup.contents;
    if (has_backup) return /*#__PURE__*/React.createElement("div", null, this.props.children);
    let ready = WalletDb.getWallet() != null;
    return /*#__PURE__*/React.createElement("div", null, this.props.noText ? null : /*#__PURE__*/React.createElement("div", {
      style: {
        textAlign: "left"
      }
    }, this.props.newAccount ? /*#__PURE__*/React.createElement(Translate, {
      component: "p",
      content: "wallet.backup_new_account",
      wallet_name: getWalletName()
    }) : null, /*#__PURE__*/React.createElement(Translate, {
      component: "p",
      content: "wallet.backup_explain"
    })), /*#__PURE__*/React.createElement(Button, {
      type: "primary",
      onClick: this.onCreateBackup.bind(this),
      style: {
        marginBottom: 10
      },
      disabled: !ready
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.create_backup_of",
      name: this.props.wallet.current_wallet
    })), /*#__PURE__*/React.createElement(LastBackupDate, null));
  }

  onCreateBackup() {
    let backup_pubkey = WalletDb.getWallet().password_pubkey;
    backup(backup_pubkey).then(contents => {
      let name = this.getBackupName();
      BackupActions.incommingBuffer({
        name,
        contents
      });
    });
  }

}

Create = connect(Create, connectObject);

class LastBackupDate extends Component {
  render() {
    if (!WalletDb.getWallet()) {
      return null;
    }

    let backup_date = WalletDb.getWallet().backup_date;
    let last_modified = WalletDb.getWallet().last_modified;
    let backup_time = backup_date ? /*#__PURE__*/React.createElement("h4", null, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.last_backup"
    }), " ", /*#__PURE__*/React.createElement(FormattedDate, {
      value: backup_date
    })) : /*#__PURE__*/React.createElement(Translate, {
      style: {
        paddingTop: 20
      },
      className: "facolor-error",
      component: "p",
      content: "wallet.never_backed_up"
    });
    let needs_backup = null;

    if (backup_date) {
      needs_backup = last_modified.getTime() > backup_date.getTime() ? /*#__PURE__*/React.createElement("h4", {
        className: "facolor-error"
      }, /*#__PURE__*/React.createElement(Translate, {
        content: "wallet.need_backup"
      })) : /*#__PURE__*/React.createElement("h4", {
        className: "success"
      }, /*#__PURE__*/React.createElement(Translate, {
        content: "wallet.noneed_backup"
      }));
    }

    return /*#__PURE__*/React.createElement("span", null, backup_time, needs_backup);
  }

}

class Upload extends Component {
  reset() {
    // debugger;
    // this.refs.file_input.value = "";
    BackupActions.reset();
  }

  render() {
    let resetButton = /*#__PURE__*/React.createElement("div", {
      style: {
        paddingTop: 20
      }
    }, /*#__PURE__*/React.createElement(Button, {
      disabled: !this.props.backup.contents,
      onClick: this.reset.bind(this)
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.reset"
    })));
    if (this.props.backup.contents && this.props.backup.public_key) return /*#__PURE__*/React.createElement("span", null, this.props.children, resetButton);
    let is_invalid = this.props.backup.contents && !this.props.backup.public_key;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", {
      ref: "file_input",
      accept: ".bin",
      type: "file",
      id: "backup_input_file",
      style: {
        border: "solid"
      },
      onChange: this.onFileUpload.bind(this)
    }), is_invalid ? /*#__PURE__*/React.createElement("h5", null, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.invalid_format"
    })) : null, resetButton);
  }

  onFileUpload(evt) {
    let file = evt.target.files[0];
    BackupActions.incommingWebFile(file);
    this.forceUpdate();
  }

}

Upload = connect(Upload, connectObject);

class NameSizeModified extends Component {
  render() {
    return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("h5", null, /*#__PURE__*/React.createElement("b", null, this.props.backup.name), " (", this.props.backup.size, " ", "bytes)"), this.props.backup.last_modified ? /*#__PURE__*/React.createElement("div", null, this.props.backup.last_modified) : null, /*#__PURE__*/React.createElement("br", null));
  }

}

NameSizeModified = connect(NameSizeModified, connectObject);

class DecryptBackup extends Component {
  static propTypes = {
    saveWalletObject: PropTypes.bool
  };

  constructor() {
    super();
    this.state = this._getInitialState();
  }

  _getInitialState() {
    return {
      backup_password: "",
      verified: false
    };
  }

  render() {
    if (this.state.verified) return /*#__PURE__*/React.createElement("span", null, this.props.children);
    return /*#__PURE__*/React.createElement("form", {
      onSubmit: this.onPassword.bind(this)
    }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.enter_password"
    })), /*#__PURE__*/React.createElement(Input, {
      type: "password",
      id: "backup_password",
      onChange: this.formChange.bind(this),
      value: this.state.backup_password
    }), /*#__PURE__*/React.createElement(Sha1, null), /*#__PURE__*/React.createElement(Button, {
      type: "primary",
      htmlType: "submit",
      onClick: this.onPassword.bind(this)
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.submit"
    })));
  }

  onPassword(e) {
    if (e) e.preventDefault();
    let private_key = PrivateKey.fromSeed(this.state.backup_password || "");
    let contents = this.props.backup.contents;
    decryptWalletBackup(private_key.toWif(), contents).then(wallet_object => {
      this.setState({
        verified: true
      });
      if (this.props.saveWalletObject) BackupStore.setWalletObjct(wallet_object);
    }).catch(error => {
      console.error("Error verifying wallet " + this.props.backup.name, error, error.stack);

      if (error === "invalid_decryption_key") {
        Notification.error({
          message: counterpart.translate("notifications.invalid_password")
        });
      } else {
        Notification.error({
          message: error
        });
      }
    });
  }

  formChange(event) {
    let state = {};
    state[event.target.id] = event.target.value;
    this.setState(state);
  }

}

DecryptBackup = connect(DecryptBackup, connectObject);

class Sha1 extends Component {
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "padding no-overflow"
    }, /*#__PURE__*/React.createElement("pre", {
      className: "no-overflow",
      style: {
        lineHeight: "1.2"
      }
    }, this.props.backup.sha1, " * SHA1"), /*#__PURE__*/React.createElement("br", null));
  }

}

Sha1 = connect(Sha1, connectObject);
export { BackupCreate, BackupRestore, Restore, NewWalletName, Download, Create, Upload, NameSizeModified, DecryptBackup, Sha1 };